import { useState, useEffect, useContext } from "react";
import { AppContext } from "@/contexts/appContexts";

const flattenCategories = (categories) => {
  const result = [];

  const traverse = (nodes) => {
    for (const node of nodes || []) {
      result.push({ id: String(node.id), name: node.name });
      if (Array.isArray(node?.children_data)) {
        traverse(node?.children_data);
      }
    }
  };

  traverse(categories);
  return result;
};

const useAlgoliaFacets = (facets) => {
  const [updatedFacets, setUpdatedFacets] = useState([]);
  const { categoryData } = useContext(AppContext);

  useEffect(() => {
    if (!facets?.length) return;

    const flatCategories = flattenCategories(categoryData?.children_data);

    const newFacets = facets.map((facet) => {
      if (facet.attribute === "categoryIds") {
        const updatedList = facet?.list?.map((item) => {
          const matchedCategory = flatCategories?.find(
            (cat) => cat?.id === item?.key
          );
          return {
            ...item,
            label: matchedCategory?.name || item?.label,
          };
        });

        return {
          ...facet,
          list: updatedList,
        };
      }
      return facet;
    });

    setUpdatedFacets(newFacets);
  }, [facets, categoryData]);

  return updatedFacets;
};

export default useAlgoliaFacets;
